<template>
  <div class="home">
    <gat-head
      :openLogin="isLogin"
      @cancelLogin="doCancelLogin"
      @confirmLogin="doConfirmlLogin"
      ref="loginfirst"
    ></gat-head>

    <!--banner-swipper-->
    <gta-banner-swiper id="home-item-1"></gta-banner-swiper>

    <!-- 实训中心 -->
    <training
      class="home-con"
      v-if="NavMenuAllStatus && NavMenuStatus.training"
    ></training>

    <!-- 模型训练 -->
    <div
      class="home-con model-practice"
      v-if="NavMenuAllStatus && NavMenuStatus.modelTraining"
    >
      <div class="model-practice-bg"></div>
      <homeModuleHead :apply="model"></homeModuleHead>
      <div class="model-center">
        <!-- <theme-head
          :title="model.title"
          :intro="model.intro"
          :more="model.more"
          :redirect="model.redirect"
          :titleBg="model.titleBg"
        ></theme-head> -->
        <!-- 步骤1、2 -->
        <div class="model-show" v-if="cropVal == 1">
          <div class="model-img">
            <div class="model-tag">
              <img
                class="tag01-border"
                src="../../../public/images/home/tag01-border.png"
                alt
              />
              <img
                class="tag01-data"
                src="../../../public/images/home/tag01-data.png"
                alt
              />
              <img
                class="tag02-border"
                src="../../../public/images/home/tag02-border.png"
                alt
              />
              <img
                class="tag02-data"
                src="../../../public/images/home/tag02-data.png"
                alt
              />
              <img
                class="tag03-border"
                src="../../../public/images/home/tag03-border.png"
                alt
              />
              <img
                class="tag03-data"
                src="../../../public/images/home/tag03-data.png"
                alt
              />
              <div class="tag04">
                <img src="../../../public/images/home/modelshow07.png" alt />
                <div class="con">
                  <h2>0基础搭建人工智能模型</h2>
                  <p>你可以在这里尝试搭建一个“海豚识别模型”</p>
                  <p>搭建完成后你可以利用这个模型识别任何图片中的“海豚”</p>
                  <span @click="toStep3">模型训练</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 步骤3 -->
        <div
          class="model-show step3"
          style="display:block;"
          v-else-if="cropVal == 2"
        >
          <div class="left-side">
            <span
              class="left-img-wrap"
              v-for="(imgItem, index) in leftImgArr"
              :key="index"
            >
              <img v-if="imgItem" :src="imgItem" />
            </span>
          </div>
          <div class="section-wrap">
            <span class="model-tips"
              >请用线框框出图片中的海豚-轮廓精确-视角多样</span
            >
            <img id="cropper-cotainer" ref="cropperImg" :src="cropImg" />
            <!-- :src="cropImgArr[cropIndex]" -->
            <span class="next-wrap" @click="nextImg">
              <i class="el-icon-right"></i>
              <!-- <img
                class="next-icon"
                src="../../../public/images/home/right.png"
              /> -->
            </span>
            <span class="pre-wrap" @click="preImg">
              <i class="el-icon-back"></i>
              <!-- <img
                class="pre-icon"
                src="../../../public/images/home/right.png"
              /> -->
            </span>
            <span class="produce-model" v-if="cropIndex == 4">
              <span @click="produceModel">生成模型</span>
            </span>
          </div>
        </div>
        <!-- 步骤4 -->
        <div class="model-show step4" v-else-if="cropVal == 3">
          <div class="model-produce">
            <img
              class="img"
              src="../../../public/images/home/aiupload.png"
              alt
            />
            <div class="model-produce-data">
              <span>
                准确率：
                <span ref="accuracy" class="text"></span>%
              </span>
              <i class="sep-line"></i>
              <span>
                速度:
                <span ref="speed" class="text"></span>KB/S
              </span>
              <i class="sep-line"></i>
              <span>
                消耗资源：
                <span ref="consume" class="text"></span>BS
              </span>
            </div>
            <div class="model-produce-being">
              <p>{{ ProductBeing.remarks }}</p>
              <p>
                数据训练中 (
                <span ref="train" class="text"></span>
                /{{ ProductBeing.all }})
              </p>
              <p>
                模拟生成
                <span ref="simulate" class="text"></span>%
              </p>
              <p>
                模拟在线部署中
                <span ref="deploy" class="text"></span>%
              </p>
            </div>
          </div>
        </div>
        <!-- 步骤5 -->
        <div class="model-show step5" v-else-if="cropVal == 4">
          <div class="model-test">
            <div class="model-test-data">
              <span>准确率：{{ TestData.accuracy }}</span>
              <i class="sep-line"></i>
              <span>速度: {{ TestData.speed }}</span>
              <i class="sep-line"></i>
              <span>消耗资源：{{ TestData.consume }}</span>
            </div>
            <div class="model-test-img">
              <div class="model-test-img-list">
                <img
                  class="img-list-item"
                  src="../../../public/images/home/modelshow03-1.png"
                  alt
                />
                <div class="san-box" v-if="scan">
                  <div class="scan-fill"></div>
                  <span class="scan-border"></span>
                  <i class="scan-data">50%</i>
                </div>
              </div>
              <div class="model-test-img-list">
                <img
                  class="img-list-item"
                  src="../../../public/images/home/modelshow03-2.png"
                  alt
                />
                <div class="san-box" v-if="scan">
                  <div class="scan-fill"></div>
                  <span class="scan-border"></span>
                  <i class="scan-data scan-data-good">90%</i>
                </div>
              </div>
              <div class="model-test-img-list">
                <img
                  class="img-list-item"
                  src="../../../public/images/home/modelshow03-3.png"
                  alt
                />
                <div class="san-box" v-if="scan">
                  <div class="scan-fill"></div>
                  <span class="scan-border"></span>
                  <i class="scan-data scan-data-bad">20%</i>
                </div>
              </div>
            </div>
            <a
              href="javascript:;"
              class="model-btn"
              @click="doScan"
              v-if="!scan"
              >测试模型</a
            >
            <a
              href="javascript:void(0);"
              class="model-btn"
              v-if="scan"
              @click="doScan"
              >去探索更多模型</a
            >
            <!--            <a href="/pretrain/1/model/list" class="model-btn" v-if="scan">去探索更多模型</a>-->
          </div>
        </div>
        <!-- 步骤6 -->
        <div class="model-show step6 step7" style="display:none;">
          <div class></div>
        </div>
      </div>
    </div>

    <!-- AI-T编辑器 -->
    <aiEditorVideo
      class="home-con"
      :projectList="projectList"
      v-if="NavMenuAllStatus && NavMenuStatus.industralApplication"
    ></aiEditorVideo>
    <!-- <div
      class="home-con training-project ai-editor-section"
      ref="homeItem2"
      id="home-item-2"
      v-if="NavMenuAllStatus && NavMenuStatus.industralApplication"
    >
      <div class="home-center">
        <div class="title-wrap">
          <el-divider></el-divider>
          <span class="title"> AI-T编辑器</span>
          <el-divider></el-divider>
        </div>
        <theme-head
          :intro="aiEditor.intro"
          :more="aiEditor.more"
          :redirect="aiEditor.redirect"
          :titleBg="aiEditor.titleBg"
        ></theme-head>
        <div class="training-box">
          <video
            class="my-video"
            muted="true"
            :autoplay="true"
            loop
            :src="aiEditorVideo"
          ></video>
        </div>
      </div>
    </div> -->

    <!-- 行业运用 -->
    <industryVideo
      class="home-con"
      :projectList="projectList"
      v-if="NavMenuAllStatus && NavMenuStatus.aiEditor"
    ></industryVideo>

    <!-- 行业应用 -->
    <!-- <training-apply
      class="home-con training-apply"
      id="training-apply"
      :projectList="projectList"
      v-if="NavMenuAllStatus && NavMenuStatus.aiEditor && projectList.length"
    >
    </training-apply> -->

    <!-- 教学中心 -->
    <teaching
      class="home-con"
      v-if="NavMenuAllStatus && NavMenuStatus.teaching"
    ></teaching>

    <!--体验实训 -->
    <experience-ai
      class="home-con host-game"
      id="host-game"
      v-if="NavMenuAllStatus && NavMenuStatus.experienceAi && experienceAi"
    ></experience-ai>

    <!-- 合作伙伴 -->
    <!-- <partners class="home-con " ref="homeItem2" v-if="NavMenuAllStatus"></partners> -->

    <!--页尾-->
    <gat-footer></gat-footer>

    <!-- 新建项目 -->
    <div class="popup-list"></div>
  </div>
</template>

<script>
import APPLICATION from '@/axios/Application/Application.js'
import ThemeHead from '@/components/home/ThemeHead.vue'
import homeModuleHead from '@/components/home/HomeModuleHead.vue' // 模块头部
import AiEditorVideo from '@/components/home/AiEditorVideo.vue' // AI编辑器模块
import IndustryVideo from '@/components/home/IndustryVideo.vue' // 行业应用模块
import gtaBannerSwiper from '@/components/home/gtaBannerSwiper.vue'
import trainingApply from '@/components/home/trainingApply.vue'
import experienceAi from '@/components/home/experienceAI.vue'
import teaching from '@/components/home/teaching.vue'
import training from '@/components/home/training.vue'
import partners from '@/components/home/partners.vue'
// import StrictCourse from '@/components/home/StrictCourse.vue'
// import GatPopup from "@/components/common/GatPopup";
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css' //载入样式
import { CountUp } from 'countup.js'
import SOURCE from '../../../public/sources/sources.js'
// import { mapActions } from "vuex";
/* eslint-disable */
let tag = process.env.VUE_APP_TAG
let NavMenuStatus = getEnv(tag).NavMenuStatus
export default {
  name: 'home',
  metaInfo: {
    title: '国匠云人工智能应用软件',
    meta: [
      {
        name: 'keyWords',
        content:
          '国匠云人工智能应用软件,人工智能通识课教育,图形化编程,积木编程,模型训练,人工智能教学',
      },
      {
        name: 'description',
        content:
          'AI Training实训平台是针对中高职、应用型本科院校对人工智能通识教育教学与实训需求，提供积木可视化编程学习、python语言基础学习、python在线编辑器、AI算法模型积木可视化调用、提供Python语言的可视化编程、多类型数据标注、AI算法模型训练及调用、在线人工智能教学、行业应用项目实训等能力，满足人工智能相关教学与实训的有效开展。',
      },
    ],
  },
  components: {
    homeModuleHead,
    ThemeHead,
    AiEditorVideo,
    IndustryVideo,
    gtaBannerSwiper,
    // trainingApply,
    experienceAi,
    teaching,
    training,
    partners,
    // StrictCourse,
    // GatFooter,
    // GatPopup
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 基地址
      NavMenuAllStatus: window.gtaAiConfig.NavMenuAllStatus,
      NavMenuStatus: NavMenuStatus,
      projectList: [], // 行业直播
      aiEditorVideo:SOURCE.pro['ai-editor'], 
      itemVal: 1, // 置于顶部模块的值;
      maxItems: null, //移动模块的最大值;
      scropStep: 20, //滚动的阈值
      toTopDom: null,
      experienceAi: window.gtaAiConfig.EXPERIENCE_AI, //是否显示体验实训
      isLogin: null,
      count: 4,
      Course: {}, //严选课程内容
      teaching: {
        // title: "实训项目",
        intro: '贯穿“课前-课中-课后” 教学闭环，打造教学智慧中心',
        more: '开始备课',
        redirect: '/projects/trainingproject',
        titleBg: '',
        bg: require('../../../public/images/home/demo.png'),
      },
      aiEditor: {
        intro: '积木代码混合三模式，零编程基础也可创作',
        more: '马上创作',
        redirect: '/ai/editor',
        titleBg: '',
        bg: require('../../../public/images/home/demo.png'),
      },
      partner: {
        bg: require('../../../public/images/home/demo.png'),
      },
      training: {
        // title: "实训项目",
        intro: '零编程基础入门，调用多种AI模型，智能硬件联动',
        more: '创建项目',
        redirect: '',
        titleBg: '',
      },
      model: {
        titleEnglish: ['MODEL', 'TRAINING'],
        title: '模型训练',
        intro: '零算法基础入门，三步搭建AI模型，支持多种应用场景',
        more: '搭建模型',
        redirect: '/pretrain/1', // TIPS:  1 是模型训练里面的其中一个，图像分类
        titleBg: require('../../../public/images/home/head03.png'),
        openUrl: 'application',
      },
      Project: {
        //实训项目
        content:
          '人物信息识别实训项目:通过创建一个自己的实训项目，进行零基础的Python语言编程及多种AI算法模型调用，实现人物信息的自动识别，包括性别、年龄、颜值、脸型、表情、情绪、动作等',
        Items: [
          {
            url: require('../../../public/images/home/project01.png'),
          },
          {
            url: require('../../../public/images/home/project02.png'),
          },
        ],
      },
      apply: {
        intro: '校企协同育人，多方课题合作，科技赋能产业',
        more: '更多应用',
        redirect: '/pretrain/2', // TIPS:  2 是模型训练里面的其中一个，图像分类
        titleBg: require('../../../public/images/home/head04.png'),
        openUrl: 'application',
        Items: [
          {
            url: require('../../../public/images/img12.png'),
            title: '智能制造',
            content:
              '人工智能辅助制造过程管控，工艺流程优化和改善，智能预测，智能盘点，生产策略计划制定和智能产线规划，实现“生产管理智能化”。',
          },
          {
            url: require('../../../public/images/img13.png'),
            title: '智慧医疗',
            content:
              '基于人工智能技术，实现智能导诊导检、医学影像的智能识别、中药饮片识别等。此外，通过智能诊断达到治未病的效果。',
          },
          {
            url: require('../../../public/images/img14.png'),
            title: '智慧教育',
            content:
              '基于云计算、物联网、大数据、人脸识别、行为分析等技术，构建全面感知、管理高效、开放共享、服务便捷的智慧校园生态环境。',
          },
        ],
      },
      doAniamte: false,
      popupActive: '',
      NewProject: {
        ProjectId: '0',
        ProjectName: '新建项目',
        BlocksFileUrl: '',
      },
      ProduceData: {
        accuracy: {
          options: {
            startVal: 0,
          },
          endCount: 100,
        },
        speed: {
          options: {
            startVal: 0,
          },
          endCount: 1024,
        },
        consume: {
          options: {
            startVal: 0,
          },
          endCount: 1024,
        },
      },
      ProductBeing: {
        remarks: '数据准备中...',
        train: {
          options: {
            startVal: 0,
          },
          endCount: 5,
        },
        all: '5',
        simulate: {
          options: {
            startVal: 0,
          },
          endCount: 100,
        },
        deploy: {
          options: {
            startVal: 0,
          },
          endCount: 100,
        },
      },
      activeImage: void 0,
      TestData: {
        accuracy: '80%',
        speed: '190',
        consume: '145BS',
      },
      cropImg: require('../../../public/images/home/modelshow05.png'),
      cropIndex: 0,
      cropImgArr: [
        require('../../../public/images/home/modelshow05.png'),
        require('../../../public/images/home/modelshow05-2.png'),
        require('../../../public/images/home/modelshow05-3.png'),
        require('../../../public/images/home/modelshow05-4.png'),
        require('../../../public/images/home/modelshow05-5.png'),
      ],
      leftImgArr: new Array(5),
      cropper: null, //croper对象
      imgName: '',
      cropVal: 1, //1,2,3,4
      scan: false,
      hasLogin: false,
    }
  },

  computed: {
    token() {
      return this.$store.state.token
    },
  },
  //导航守卫
  beforeRouteLeave(to, from, next) {
    var hasLogin = sessionStorage.getItem('hasLogin')
    var token = this.$store.state.token
    if (hasLogin && token) {
      //登录状态
      this.isLogin = ''
      next()
    } else {
      next(false)
      this.isLogin = 'login'
      //调用GatHead.vue方法-出现登陆弹框
      this.$refs.loginfirst.activeLoginPopup()
    }
    //取消滚动监听
    window.removeEventListener('scroll', this.windowScroll)
  },
  watch: {
    isLogin(isLogin) {
      this.$forceUpdate
    },
    token(val) {
      if (val) {
        this.getTradeVideoList()
      }
    },
  },
  created() {
    this.getTradeVideoList() // 获取行业直播信息
  },
  mounted() {
    this.maxItems = document.getElementsByClassName('home-con').length

    this.$nextTick(() => {
      window.addEventListener('scroll', this.windowScroll)
      // window.addEventListener("scroll", this.setModulePos);//设置模块的位置
    })
    this.hasLogin = sessionStorage.getItem('hasLogin')

    // var mySwiper2 = new Swiper('#swiper2', {
    // 	loop : true,
    // 	speed : 2000,
    // 	autoplay : {
    // 		delay : 5000,
    // 		stopOnLastSlide : false,
    // 		disableOnInteraction : true,
    // 	},
    // 	pagination : '.swiper-pagination'
    // })

    // mySwiper2.el.onmouseover = function() { //鼠标进入
    // 	mySwiper2.autoplay.stop();  //轮播停止
    // }
    // mySwiper2.el.onmouseout = function() { //鼠标离开
    // 	var v_len = $("#swiper2 .swiper-slide").find("video").length
    //        	    for(var i = 0;i<v_len;i++){
    //        	      $("#swiper2 .swiper-slide").find("video").get(i).pause(); //把所有停止
    //      	    }
    // 	mySwiper2.autoplay.start(); //轮播开始
    // }

    // $("#swiper2 .swiper-slide video").on("click", function() {
    // 	var isPaused = $(this).get(0).paused  //视频是否在播放
    // 	if(isPaused){ // 我点击的这个是暂停的
    // 		$(this).get(0).play(); //播放
    // 	}else{
    // 		$(this).get(0).pause(); //停止
    // 	}
    // });
  },
  methods: {
    // 获取行业直播信息
    getTradeVideoList() {
      let data = {
        // type: "1",
        videoName: '',
        pageNum: 1,
        pageSize: 10,
      }
      APPLICATION.getTradeVideoList(data).then((result) => {
        if (result.isSuccess) {
          let imgUrl = [];
          let videoUrl = [];
          let dataList = result.data.records;
          // dataList.forEach(item => {
          //   if ( !(/https/i.test(item.videoUrl)) ) {
          //     videoUrl = item.videoUrl.split('/UploadFiles');
          //     item.videoUrl = this.photoBaseUrl + '/UploadFiles' + videoUrl[1];
          //   }
          //   if ( !(/https/i.test(item.imgUrl)) ) {
          //     imgUrl = item.imgUrl.split('/UploadFiles');
          //     item.imgUrl = this.photoBaseUrl + '/UploadFiles' +  imgUrl[1];
          //   }
          // });
          this.projectList = dataList;
        }
      })
    },
    // 去到直播页面
    onLive(val) {
      this.$router.push({
        name: 'application-live',
        query: { videoId: val },
      })
    },
    setModulePos() {
      // 模块
      let { itemVal } = this,
        itemId = `home-item-2`,
        scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop,
        itemDom = this.$refs.homeItem2
      this.toTopDom = itemDom
      // if(scrollTop >20){
      //   this.goToTop();//跳转到顶部
      // }
      // itemDom =document.getElementById(`home-item-2`)
      // itemId ="home-item-"+(itemVal+1),
      // document.body.scrollTop = 10
      // document.documentElement.scrollTop = 10
      // itemDom.scrollIntoView();

      // document.getElementById(`home-item-2`).scrollTop =0;
      // itemDom.scrollTop =0;
      // itemDom.scrollIntoView({
      //   behavior: 'smooth',    //平滑滚动，爽，其他还有 instant
      //   block: 'start'  //元素到页面顶部，其他还有 end, center
      // })
      this.itemVal++
      // itemDom
    },
    goToTop() {
      document.body.scrollTop = 80
      document.documentElement.scrollTop = 80
    },
    windowScroll() {
      if (!this.NavMenuAllStatus) {
        return
      }
      // 滚动条距离页面顶部的距离
      this.setModulePos()
      if (this.cropVal != 1) return //不是第一个步骤时，不执行
      let homeConDoms = document.getElementsByClassName('home-con'),
        tag01Border = document.getElementsByClassName('tag01-border')[0],
        tag01Data = document.getElementsByClassName('tag01-data')[0],
        tag02Border = document.getElementsByClassName('tag02-border')[0],
        tag02Data = document.getElementsByClassName('tag02-data')[0],
        tag03Border = document.getElementsByClassName('tag03-border')[0],
        tag03Data = document.getElementsByClassName('tag03-data')[0],
        tag04 = document.getElementsByClassName('tag04')[0],
        tagList = [
          //数组位置代表动画顺序
          tag01Border,
          tag01Data,
          tag02Border,
          tag02Data,
          tag03Border,
          tag03Data,
          tag04,
        ], //滚动高度
        scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop,
        offsetTop_1 = document.getElementsByClassName('model-practice')[0]
          .offsetTop, // 模型训练的文档高度
        modelIndex,
        offsetTop_2;

      homeConDoms = Array.from(homeConDoms)
      homeConDoms.forEach((item, index) => {
        let cName = item.className
        if (/model-practice/.test(cName)) {
          modelIndex = index
        }
      })

      let dom =
        homeConDoms[modelIndex + 1] ||
        homeConDoms[modelIndex + 2] ||
        homeConDoms[modelIndex + 3];
      if (dom) {
        offsetTop_2 = dom.offsetTop;
      }

      if (offsetTop_2 - scrollTop > 220 && offsetTop_1 - scrollTop < 120 && !this.doAniamte ) {
        //doAniamte表示只执行一次动画效果
        var len = tagList.length

        for (let i = 0; i < len; i++) {
          setTimeout(() => {
            tagList[i].style.opacity = 1
            // count += 1000 + 200 * i
          }, 1000 + 200 * i)
        }
        this.doAniamte = true
      } else {
        for (let i = 0, len = tagList.length; i < len; i++) {
          tagList[i].style.opacity = 0
        }
        this.doAniamte = false //又恢复执行
      }
    },

    // 取消弹窗
    cancelPopup() {
      this.popupActive = ''
    },
    // createNewProject() {
    //   var token = this.token,
    //       projectName = this.NewProject.ProjectName,
    //       data;
    //   // 项目命名不能为空和超出限制的字符长度
    //   if (this.$util.checkStrNullOrTooLong.call(this, [projectName])) {
    //     return;
    //   }
    //   data = {
    //     ProjectName: projectName
    //   };
    //   ProProject.createNewProject(token, data).then(result => {
    //     if (result.isSuccess) {
    //       // // 插到列表前面
    //       // this.NewProject = result.Data;
    //       // this.Project.Items.splice(0, 1, this.NewProject);

    //       this.redirectToTraining(result.Data.ProjectId);
    //       this.cancelPopup();
    //     } else if (result.ErrorCode === 40101) {
    //       // 项目名称重复，重新输入名称。
    //       this.$message({
    //         message: "项目名称重复，请重新输入名称",
    //         type: "error",
    //         duration: 2000
    //       });
    //     }
    //   });
    // },
    // 跳转
    redirectToTraining(projectId) {
      this.$router.push({
        name: 'projects-training',
        query: { projectid: projectId },
      })
    },
    // 数字叠加
    accuracyCountUp() {
      let num = new CountUp(
        this.$refs.accuracy,
        this.ProduceData.accuracy.endCount,
        this.ProduceData.accuracy.options
      )
      if (!num.error) {
        num.start()
      } else {
        console.error(num.error)
      }
    },
    speedCountUp() {
      let num = new CountUp(
        this.$refs.speed,
        this.ProduceData.speed.endCount,
        this.ProduceData.speed.options
      )
      if (!num.error) {
        num.start()
      } else {
        console.error(num.error)
      }
    },
    consumeCountUp() {
      let num = new CountUp(
        this.$refs.consume,
        this.ProduceData.consume.endCount,
        this.ProduceData.consume.options
      )
      if (!num.error) {
        num.start()
      } else {
        console.error(num.error)
      }
    },
    trainCountUp() {
      let num = new CountUp(
        this.$refs.train,
        this.ProductBeing.train.endCount,
        this.ProductBeing.train.options
      )
      if (!num.error) {
        num.start()
      } else {
        console.error(num.error)
      }
    },
    simulateCountUp() {
      let num = new CountUp(
        this.$refs.simulate,
        this.ProductBeing.simulate.endCount,
        this.ProductBeing.simulate.options
      )
      if (!num.error) {
        num.start()
      } else {
        console.error(num.error)
      }
    },
    deployCountUp() {
      let num = new CountUp(
        this.$refs.deploy,
        this.ProductBeing.deploy.endCount,
        this.ProductBeing.deploy.options
      )
      if (!num.error) {
        num.start()
      } else {
        console.error(num.error)
      }
    },
    initCroper() {
      var self = this
      var cropperImg = document.getElementById('cropper-cotainer')
      this.cropper = new Cropper(cropperImg, {
        aspectRatio: NaN, //裁剪比例
        autoCrop: false, //不自动裁剪
        zoomable: false, //启用缩放图像。
        background: false, //是否在容器上显示网格背景
        // zoomOnWheel:false,//是否允许通过鼠标滚轮来缩放图片
        dragMode: 'crop', // 'crop':创建一个新的裁剪框    'move':移动画布  'none':do nothing
        viewMode: 1, // 0:无限制; 1:将裁剪框限制为不超过画布的大小
        data: {}, // 如果您已经存储了以前的裁剪数据，将在构建时自动传递给setData方法。
        preview: '', //添加额外的元素（容器）进行预览。
        autoCropArea: 1, //介于0和1之间的数字。定义自动裁剪区域大小（百分比）
        cropBoxMovable: true, // 启用通过拖动来移动裁剪框。
        cropBoxResizable: true, // 启用通过拖动调整裁剪框的大小。。
        toggleDragModeOnDblclick: true, //在裁剪器上点击两次时，启用“切割”和“移动”之间切换拖动模式。
        crop(event) {
          // console.log(event.detail.x);
        },
        ready() {
          // this.cropper.crop(); //进行裁剪状态
        },
        cropend() {
          var getImage = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
          if (getImage) {
            var cropIndex = self.cropIndex
            self.leftImgArr.splice(cropIndex, 1, [getImage])
            self.$forceUpdate
          }
        },
      })
    },
    getCroppedCanvas() {
      this.cropper.getCroppedCanvas({
        width: 160,
        height: 90,
        minWidth: 256,
        minHeight: 256,
        maxWidth: 4096,
        maxHeight: 4096,
        fillColor: '#fff',
        imageSmoothingEnabled: false,
        imageSmoothingQuality: 'high',
      })
    },
    nextImg() {
      if (this.cropIndex < 4) {
        this.cropIndex += 1
      } else {
        this.cropIndex = 4
      }
      this.cropImg = this.cropImgArr[this.cropIndex]
      this.cropper.replace(this.cropImg)
      this.$forceUpdate
    },
    preImg() {
      if (this.cropIndex > 0) {
        this.cropIndex -= 1
        this.cropImg = this.cropImgArr[this.cropIndex]
        this.cropper.replace(this.cropImg)
        this.$forceUpdate
      }
    },
    toStep3() {
      this.cropVal = 2 //跳转到步骤3
      setTimeout(() => {
        this.initCroper() //初始化步骤3
      }, 50)
    },
    produceModel() {
      var self = this,
        leftImgArr = this.leftImgArr,
        finished = true,
        len = leftImgArr.length
      for (let i = 0; i < len; i++) {
        if (!leftImgArr[i]) {
          this.$message({
            message: `请完成第${i + 1}张图片截图`,
            type: 'error',
            duration: 2000,
          })
          finished = false
          return
        }
      }
      if (!finished) {
        return
      }
      this.cropVal = 3 //跳转到步骤4
      setTimeout(() => {
        this.accuracyCountUp()
        this.speedCountUp()
        this.consumeCountUp()
        this.trainCountUp()
        this.simulateCountUp()
        this.deployCountUp()
      }, 100)
      setTimeout((res) => {
        self.cropVal = 4
      }, 3500)
    },
    doScan() {
      // if(this.token)
      this.scan = true
      // this.$router.push('/pretrain/1/model/list')
      this.$router.push('/pretrain/1/dataset/list')
    },
    doCancelLogin() {
      this.isLogin = ''
      //  this.hasLogin = false;
    },
    doConfirmlLogin() {},
  }, //methods end
}
</script>
<style lang="scss" scoped>
@import './home.scss';
</style>
<style>
.a1cropper-cotainer {
  transform: scale(1.05);
}
</style>
